module.exports = __webpack_public_path__ + "img/scroll.5c6868f5.png";